import { MatrixDescriptor } from './types';

export const CIENCIAS_NATUREZA_DESCRIPTORS: MatrixDescriptor[] = [
  // --- FÍSICA ---
  {
    id: 'FIS_D1',
    subject: 'FISICA',
    code: 'D1',
    theme: 'Tema 1 – Movimentos - variações e conservações',
    description: 'Identificar diferentes formas e linguagens para representar movimentos, como: trajetórias, gráficos, tabelas, funções e linguagem discursiva.',
    keywords: ['trajetória', 'gráfico de movimento', 'tabela de velocidades', 'espaço x tempo'],
  },
  {
    id: 'FIS_D2',
    subject: 'FISICA',
    code: 'D2',
    theme: 'Tema 1 – Movimentos - variações e conservações',
    description: 'Classificar movimentos segundo características comuns, como trajetórias e variações de velocidade.',
    keywords: ['mru', 'muv', 'uniforme', 'acelerado', 'retardado'],
  },
  {
    id: 'FIS_D3',
    subject: 'FISICA',
    code: 'D3',
    theme: 'Tema 1 – Movimentos - variações e conservações',
    description: 'Relacionar e calcular grandezas que caracterizam movimentos.',
    keywords: ['velocidade média', 'aceleração', 'deslocamento', 'tempo', 'torricelli', 'frenagem', 'freia'],
  },
  {
    id: 'FIS_D6',
    subject: 'FISICA',
    code: 'D6',
    theme: 'Tema 1 – Movimentos - variações e conservações',
    description: 'Prever e avaliar situações cotidianas que envolvam movimentos, utilizando as leis de Newton.',
    keywords: ['leis de newton', 'força resultante', 'inércia', 'ação e reação', 'massa'],
  },
  {
    id: 'FIS_D7',
    subject: 'FISICA',
    code: 'D7',
    theme: 'Tema 1 – Movimentos - variações e conservações',
    description: 'Identificar fontes e transformações de energia em movimentos, em diferentes equipamentos e máquinas, em atividades físicas e esportivas.',
    keywords: ['energia cinética', 'energia potencial', 'conservação de energia mecânica'],
  },
  {
    id: 'FIS_D8',
    subject: 'FISICA',
    code: 'D8',
    theme: 'Tema 1 – Movimentos - variações e conservações',
    description: 'Calcular o trabalho mecânico de forças de diferentes naturezas, em exemplos de situações reais.',
    keywords: ['trabalho mecânico', 'força constante', 'atrito', 'deslocamento'],
  },
  {
    id: 'FIS_D10',
    subject: 'FISICA',
    code: 'D10',
    theme: 'Tema 1 – Movimentos - variações e conservações',
    description: 'Reconhecer o conceto de pressão como resultante da aplicação de uma força sobre área determinada e identificar a presença de pressão atmosférica em situações-problemas.',
    keywords: ['pressão', 'força sobre área', 'pressão atmosférica'],
  },
  {
    id: 'FIS_D11',
    subject: 'FISICA',
    code: 'D11',
    theme: 'Tema 1 – Movimentos - variações e conservações',
    description: 'Reconhecer os elementos importantes - densidade, peso e pressão - presentes no experimento de Torricelli para a determinação da pressão atmosférica.',
    keywords: ['experimento de torricelli', 'barômetro', 'mercúrio', 'pressão atmosférica'],
  },
  {
    id: 'FIS_D12',
    subject: 'FISICA',
    code: 'D12',
    theme: 'Tema 1 – Movimentos - variações e conservações',
    description: 'Calcular e interpretar o resultado da pressão em um ponto situado abaixo da superfície livre de um líquido.',
    keywords: ['profundidade', 'hidrostática', 'líquido', 'stevin', 'pressão absoluta', 'submarino'],
  },
  {
    id: 'FIS_D14',
    subject: 'FISICA',
    code: 'D14',
    theme: 'Tema 1 – Movimentos - variações e conservações',
    description: 'Calcular e identificar a força de empuxo em situações do cotidiano; estabelecer comparação entre valores de densidade de um corpo sólido e um líquido, a fim de determinar a posição de equilíbrio do corpo quando colocado num líquido.',
    keywords: ['empuxo', 'arquimedes', 'flutuação', 'densidade relativa'],
  },
  {
    id: 'FIS_D19',
    subject: 'FISICA',
    code: 'D19',
    theme: 'Tema 3 – Calor, ambiente e usos de energia',
    description: 'Identificar fenômenos, fontes e sistemas que envolvem trocas de calor em processos naturais ou tecnológicos.',
    keywords: ['condução', 'convecção', 'irradiação', 'calor', 'aquecimento'],
  },
  {
    id: 'FIS_D22',
    subject: 'FISICA',
    code: 'D22',
    theme: 'Tema 3 – Calor, ambiente e usos de energia',
    description: 'Estimar trocas de calor envolvidas em fenômenos naturais ou em processos tecnológicos.',
    keywords: ['calor sensível', 'calor específico', 'massa de água', 'temperatura', 'q = m c delta t'],
  },
  {
    id: 'FIS_D28',
    subject: 'FISICA',
    code: 'D28',
    theme: 'Tema 3 – Calor, ambiente e usos de energia',
    description: 'Avaliar e comparar a potência e o rendimento de máquinas térmicas a partir de dados reais.',
    keywords: ['máquina térmica', 'rendimento', 'carnot', 'fonte quente', 'fonte fria'],
  },
  {
    id: 'FIS_D30',
    subject: 'FISICA',
    code: 'D30',
    theme: 'Tema 4 – Som, imagem e comunicação',
    description: 'Identificar e discriminar características físicas de ondas sonoras.',
    keywords: ['som', 'onda sonora', 'frequência', 'comprimento de onda', 'radar', 'velocidade do som'],
  },
  {
    id: 'FIS_D37',
    subject: 'FISICA',
    code: 'D37',
    theme: 'Tema 5 – Equipamentos elétricos',
    description: 'Identificar elementos e grandezas elétricas presentes em contas de luz, embalagens chapinhas ou impressos de fabricação de aparelhos e equipamentos.',
    keywords: ['kwh', 'conta de luz', 'tensão', 'potência', 'hp', 'watt', 'carro elétrico'],
  },
  {
    id: 'FIS_D39',
    subject: 'FISICA',
    code: 'D39',
    theme: 'Tema 5 – Equipamentos elétricos',
    description: 'Estimar consumo e custo de energia elétrica residencial.',
    keywords: ['consumo', 'tarifa', 'economia', 'energia elétrica', 'custo mensal'],
  },
  {
    id: 'FIS_D42',
    subject: 'FISICA',
    code: 'D42',
    theme: 'Tema 5 – Equipamentos elétricos',
    description: 'Relacionar elementos e grandezas mensuráveis de equipamentos e circuitos elétricos (corrente, tensão, resistência, potência).',
    keywords: ['lei de ohm', 'resistor', 'corrente', 'ddp', 'u = r i', 'circuito elétrico'],
  },

  // --- QUÍMICA ---
  {
    id: 'QUI_D8',
    subject: 'QUIMICA',
    code: 'D8',
    theme: 'Tema 1 – Transformações químicas na natureza e no sistema produtivo',
    description: 'Realizar cálculos para estimar massas, massas molares, quantidades de matéria (mol), número de partículas e energia envolvida em transformações de combustão e em transformações químicas em geral, incluídos cálculos com rendimento e pureza variados.',
    keywords: ['estequiometria', 'mol', 'massa molar', 'rendimento', 'pureza', 'combustão'],
  },
  {
    id: 'QUI_D11',
    subject: 'QUIMICA',
    code: 'D11',
    theme: 'Tema 1 – Transformações químicas na natureza e no sistema produtivo',
    description: 'Interpretar reações de neutralização entre ácidos e bases fortes de Arrhenius como reações entre H+ e OH- e prever a quantidade de base forte que deve ser adicionada a um ácido forte.',
    keywords: ['neutralização', 'ácido forte', 'base forte', 'titulação', 'h+', 'oh-'],
  },
  {
    id: 'QUI_D15',
    subject: 'QUIMICA',
    code: 'D15',
    theme: 'Tema 2 – Transformações químicas que apresentam rendimentos inferiores aos previstos estequiometricamente: equilíbrios químicos',
    description: 'Utilizar valores da escala de pH para classificar soluções aquosas como ácidas, básicas e neutras (a 25ºC), e calcular valores de pH a partir das concentrações de H+, e vice-versa.',
    keywords: ['ph', 'acidez', 'alcalinidade', 'solução aquosa', 'logaritmo de h+'],
  },
  {
    id: 'QUI_D21',
    subject: 'QUIMICA',
    code: 'D21',
    theme: 'Tema 3 – Materiais e suas propriedades',
    description: 'Analisar e reconhecer os grupos funcionais por meio de fórmulas estruturais de hidrocarbonetos, aminas, amidas, ácidos carboxílicos, ésteres, éteres, aldeídos, cetonas, alcoóis, fenóis e compostos aromáticos.',
    keywords: ['funções orgânicas', 'álcool', 'ácido carboxílico', 'amina', 'éster', 'hidrocarboneto'],
  },
  {
    id: 'QUI_D30',
    subject: 'QUIMICA',
    code: 'D30',
    theme: 'Tema 4 – Transformações químicas que envolvem diretamente a energia elétrica',
    description: 'Relacionar a energia elétrica produzida e consumida na transformação química com os processos de oxidação e redução, e aplicar esses conhecimentos para calcular a FEM de uma pilha galvânica.',
    keywords: ['pilha', 'eletrólise', 'oxidação', 'redução', 'potencial de redução', 'fem', 'anodo', 'catodo'],
  },

  // --- BIOLOGIA ---
  {
    id: 'BIO_D18',
    subject: 'BIOLOGIA',
    code: 'D18',
    theme: 'Tema 4 – identidade dos seres vivos: organização celular e funções vitais básicas',
    description: 'Relacionar as funções vitais das células com suas organelas e biomoléculas.',
    keywords: ['mitocôndria', 'ribossomo', 'retículo', 'complexo golgiense', 'organelas'],
  },
  {
    id: 'BIO_D32',
    subject: 'BIOLOGIA',
    code: 'D32',
    theme: 'Tema 6 – Diversidade da vida: a Biologia dos animais',
    description: 'Identificar os principais processos físicos e químicos envolvidos na fisiologia humana (sistema digestório, respiratório, cardiovascular, imunológico, urinário, endócrino e nervoso).',
    keywords: ['fisiologia humana', 'circulatório', 'digestório', 'hormônio', 'respiração'],
  },
  {
    id: 'BIO_D38',
    subject: 'BIOLOGIA',
    code: 'D38',
    theme: 'Tema 7 – A interdependência da vida',
    description: 'Identificar níveis tróficos em cadeias e teias alimentares, reconhecendo carnívoros, herbívoros e onívoros.',
    keywords: ['cadeia alimentar', 'teia alimentar', 'nível trófico', 'produtor', 'consumidor'],
  },
  {
    id: 'BIO_D50',
    subject: 'BIOLOGIA',
    code: 'D50',
    theme: 'Tema 9 – Hereditariedade: a transmissão das características genéticas',
    description: 'Compreender e aplicar as Leis de Mendel para explicar os princípios básicos da herança genética.',
    keywords: ['mendel', 'leis de mendel', 'alelo', 'genótipo', 'fenótipo', 'herança'],
  },
];
